<template>
  <form
    :class="{
      'offset-mobile-menu': offsetMobileMenu,
    }"
    class="form"
    @submit.prevent="() => null"
  >
    <header v-if="title" class="header">
      <heading align="center" tag="h3">{{ title }}</heading>
    </header>

    <FormFields
      v-if="fields.length"
      :fields="fields"
      :class="{ loading: loading }"
      class="fields"
      @init="loadingAssets = true"
      @loading="(value) => (loadingAssets = value)"
    />

    <FormFieldsRecap
      v-else-if="fieldsRecap.length"
      :class="{ loading: loading }"
      class="fields"
      :fields-recap="fieldsRecap"
    />

    <FormNav
      :sticky="stickyNav"
      :has-previous="hasPrevious"
      :has-cancel="hasCancel"
      class="nav"
      :label-submit="labelSubmit"
      :loading="loading"
    />

    <slot name="aside"> </slot>

    <div v-if="hasFieldsReaquired || addCgu" class="legals">
      <p v-if="hasFieldsReaquired" class="required-field">
        * champs obligatoires
      </p>
      <a v-if="addCgu" class="cgu" href="/cgu">
        Conditions générales d’utilisation
      </a>
    </div>
  </form>
</template>
<script setup lang="ts">
interface Props {
  labelSubmit?: string;
  stickyNav?: boolean;
  addCgu?: boolean;
  offsetMobileMenu?: boolean;
}
defineProps({
  labelSubmit: null,
  stickyNav: { type: Boolean, default: true },
  addCgu: { type: Boolean, default: false },
  offsetMobileMenu: { type: Boolean, default: true }
});
const emit = defineEmits(["cancel"]);

const { open: openDialogError } = useDialogErrorMessage();

const {
  title,
  fields,
  submit,
  previous,
  hasPrevious,
  hasCancel,
  releaseError,
  // formFieldsData: { edited },
  formFieldsValidation: { validated },
  formFieldsRecap: { fieldsRecap },
  loading: loadingRequest,
  hasFieldsReaquired,
  formNavigation,
  error,
} = inject(INJECT_FORM_PAGE);

const { onSubmit, onCancel, onPrevious, lockState } = formNavigation;

const loadingAssets = ref<boolean>(false);

const loading = computed(() => {
  return loadingRequest.value || loadingAssets.value;
});

onSubmit(async () => {
  if (lockState.value > 0) return;

  if (!validated.value) return;
  await submit();
});

onCancel(() => {
  if (lockState.value > 0) return;
  emit('cancel');
});

onPrevious(() => {
  if (lockState.value) return;
  previous();
});

watch(
  () => error.value,
  (err) => {
    if (err) {
      openDialogError('Une erreur est survenue', err.message, releaseError);
    }
  }
);
</script>
<style lang="scss" scoped>
.header,
.fields {
  &.loading {
    transition: all 200ms $ease-out-quad;
    opacity: 0.5;
    pointer-events: none;
    filter: grayscale(1);
  }
}

.fields {
  align-self: flex-start;
}

.form {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  height: 100%;
  gap: var(--gap_l);
  place-items: center;
}

header {
  padding: 0 2rem;
  @include above('l') {
    padding: 0;
  }
}

.required-field {
  text-align: right;
  @include font('s', 300);
}

.nav {
  align-self: flex-start;
}

.legals {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  align-self: flex-end;
  justify-content: space-between;
  width: 100%;
  margin-top: 2rem;
}

a.cgu {
  @include font('s', 300);

  text-decoration: underline;
  &:hover,
  &:focus {
    color: var(--color_neutral_900);
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
